import styled, { css } from 'styled-components';

// React-shared.
import { sm } from '@exonet/react-shared/lib/styled';

export const FullLabel = styled.span`
  display: none;

  ${sm(css`
    display: inherit;
  `)}
`;

export const SmallLabel = styled.span`
  display: inherit;

  ${sm(css`
    display: none;
  `)}
`;
